import { usePersonalProject } from '../hooks/useTasks';
import { TasksView } from '../components/tasks/TasksView';
import { SkeletonTable } from '../components/ui/Skeleton';
import { useI18n } from '../contexts/I18nContext';

/**
 * "Sarcini personale" — the caller's private task list. Same Linear-style
 * <TasksView /> as the global Tasks page, but locked to the user's hidden
 * personal project (lazily created server-side on first visit). Personal tasks
 * are visible only to their owner — never to other users, including admins.
 */
export function PersonalTasksPage() {
  const { t } = useI18n();
  const { data: personalProject, isLoading, isError } = usePersonalProject();

  return (
    <div className="w-full p-4 sm:p-6 lg:p-8">
      {isLoading && <SkeletonTable rows={8} columns={6} />}
      {isError && <p className="text-red-600">{t('personalTasks.error')}</p>}
      {personalProject && <TasksView projectId={personalProject.id} hideProjectFilter personal />}
    </div>
  );
}
